import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app" }

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { workspacesApi } from '@/workspaces/workspaces';
import { config } from '@/config/config';
import connectWidget from '@/connect/connectWidget';
import { useAuth } from '@/authentication/useAuth';
import NavBar from '@shared/components/navbar/NavBar.vue';

// Vuex store

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

// Router and Route
const router = useRouter();
const route = useRoute();
const { userId, isAuthenticated, logout } = useAuth();

// Computed properties (Vuex getters)
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const activeRoute = computed(() => String(route?.name || ''));

// Lifecycle hook
onMounted(async () => {
  await addConnectWidget();
  await setupRouteHooks();
});

function isPageThatAllowsUnauthenticatedAccess() {
  return routeStartsWith('register');
}

function routeStartsWith(prefix: string) {
  return activeRoute.value.startsWith(prefix);
}

async function getUserCredentials() {
  if (config().webAssistantWorkspaceId && isAuthenticated.value) {
    const token = await workspacesApi.createUserTokenForConnect();
    return { token, userId: userId.value };
  }
}

async function addConnectWidget() {
  const userCredentials = await getUserCredentials();
  if (userCredentials) {
    connectWidget.addWebAssistant(userCredentials.userId, userCredentials.token);
  }
}

async function setupRouteHooks() {
  router.afterEach(async () => {
    const userCredentials = await getUserCredentials();
    if (userCredentials) {
      await connectWidget.update(userCredentials.userId, userCredentials.token);
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    (_unref(isAuthenticated) || isPageThatAllowsUnauthenticatedAccess())
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["content-wrapper", { 'without-navbar': !_unref(isAuthenticated) }])
        }, [
          (_openBlock(), _createBlock(_component_router_view, {
            key: currentWorkspace.value.id
          }))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})